/* eslint-disable consistent-return */
import React from "react";
import { Alert, Circle, SendToast, Text } from "@networkraildigitalfactory/components";
import { X } from "phosphor-react";
import { capitalise } from "../../services/utils";
import styles from "./CreateReviewPrep.module.css";

/* eslint-disable array-callback-return */
export const generateFileBuffer = (evidence) => {
  const preppedEvidence = [];
  if (!evidence) {
    return preppedEvidence;
  }
  evidence.forEach((file) => {
    if (file.name) {
      const reader = new FileReader();
      reader.onabort = () => console.warn("file reading was aborted");
      reader.onerror = () => console.warn("file reading has failed");
      const binaryStr = reader.result;
      const { name, type, size } = file;
      preppedEvidence.push({
        fileName: name,
        fileType: type || "Application",
        fileData: binaryStr,
        fileSize: size,
      });
      reader.readAsArrayBuffer(file);
    }
  });
  return preppedEvidence;
};

export const buildObjectiveAnswers = (objectives, reviewType, currentPrep) => {
  const objectiveAnswers = [];
  Object.keys(objectives).map((key) => {
    if (key.includes("objective")) {
      const objectiveId = key.split("objective").pop();
      const sortedPrep = currentPrep?.objectives?.filter(
        (existingValue) => existingValue.objective._id === objectiveId
      )[0];
      if (reviewType === "eoy") {
        objectiveAnswers.push({
          objective: objectiveId,
          interimProgress: sortedPrep?.interimProgress || "",
          eoyProgress: objectives[key],
        });
      } else {
        objectiveAnswers.push({
          objective: objectiveId,
          interimProgress: objectives[key],
          eoyProgress: sortedPrep?.eoyProgress || "",
        });
      }
    }
  });
  return objectiveAnswers;
};

export const getSubmissionConfig = (type) => {
  let config;
  switch (type) {
    case "save":
      config = {
        toastMsg: "Your prep has been saved as a draft",
        status: "draft",
      };
      break;
    default:
      config = {
        toastMsg: "Your prep has been submitted",
        status: "submitted",
      };
      break;
  }
  return config;
};

export const generateReviewTypeKey = (reviewType, key, lowerCaseVariant) => {
  if (lowerCaseVariant) {
    return `${reviewType}${key}`;
  }
  return `is${capitalise(reviewType)}${key}`;
};

export const createErrorNotice = (text) => {
  return (
    <div className={styles.errorNotice}>
      <Circle color="#37519D" size={20}>
        <X color="#fff" size={14} weight="bold"></X>
      </Circle>
      <Text wrapper="h3" type="header" style={{ fontSize: 20 }}>
        {text}
      </Text>
    </div>
  );
};

// eslint-disable-next-line consistent-return
export const eoyReviewAlerts = (currentPrep) => {
  if (currentPrep?.interim?.isInterimCompleted) {
    return (
      <>
        <Alert
          color="blue"
          title="Line Manager’s interim comment"
          message={currentPrep?.interim?.interimFeedback}
          style={{
            margin: "24px 0",
          }}
        />
        {!currentPrep?.interim?.interimPrep && createErrorNotice("No interim prep submitted")}
      </>
    );
  }
  if (currentPrep?.interim?.status === "submitted") {
    return createErrorNotice("No interim review completed");
  }
  return createErrorNotice("No interim prep or review completed");
};

export const addFiles = (newFiles, existingFiles, updateFiles) => {
  let hasFilesWithDuplicateName = false;
  const filesToAdd = [];
  newFiles.map((newFile) => {
    if (existingFiles) {
      const duplicates = existingFiles.filter(
        (existingFile) =>
          existingFile.name === newFile.name || existingFile.fileName === newFile.name
      );
      if (duplicates.length > 0) {
        hasFilesWithDuplicateName = true;
        return false;
      }
    }
    filesToAdd.push(newFile);
  });
  if (hasFilesWithDuplicateName) {
    SendToast("One or more of the file name(s) you are trying to add already exists", "error");
  }
  updateFiles((prevState) => (prevState ? prevState.concat(filesToAdd) : filesToAdd));
};

export const removeFiles = (event, fileToRemoveIndex, clearError, file, hasFile) => {
  event.stopPropagation();
  clearError("evidence");
  file.splice(fileToRemoveIndex, 1);
  hasFile(file);
};
